export const TYPOGRAPHY = {
  // Font Families
  fontFamilyHeading: '\'Open Sans\', \'Arial\', sans-serif',
  fontFamilyBody: '\'Open Sans\', \'Georgia\', serif',
  fontFamilyMono: '\'Open Sans\', \'Georgia\', serif',

  // Sizes
  // Base font-size: 10px
  bodyReset: '16px',
  fontSizeBase: '16px',

  //Body Variables
  bodyLarge: '1.125rem',
  bodyLargeLineHeight: '1.3',

  bodyBase: '1rem',
  bodyBaseLineHeight: '1.5',

  bodySmall: '0.8125rem',
  bodySmallLineHeight: '1.2',

  //Button Variables
  buttonSmall: '0.75rem',
  buttonSmallLineHeight: '1',

  buttonBase: '0.875rem',
  buttonBaseLineHeight: '1',

  buttonLarge: '1rem',
  buttonLargeLineHeight: '1',

  //Display Heading Variables
  displayExtraLarge: '2.5rem',
  displayExtraLargeLineHeight: '1.1',

  displayLarge: '2rem',
  displayLargeLineHeight: '1.1',

  displayMedium: '1.5rem',
  displayMediumLineHeight: '1.125',

  displaySmall: '1rem',
  displaySmallLineHeight: '1.25',

  displayNumber: '1.125rem',
  displayNumberLineHeight: '1',

  //Heading Variables
  headingPage: '1.75rem',
  headingPageLineHeight: '1.1',

  heading: '1.25rem',
  headingLineHeight: '1.2',

  headingSubheading: '1.125rem',
  headingSubheadingLineHeight: '1.2',

  headingLabel: '0.75rem',
  headingLabelLineHeight: '1.5',

  // Weights
  fontWeightLight: '300',
  fontWeightBase: '400',
  fontWeightBold: '700',

  // Styles
  fontStyleItalic: 'italic',

  // Text Alignment
  textAlignCenter: 'center',
  textAlignLeft: 'left',
  textAlignJustify: 'justify',
  textAlignRight: 'right',

  // Text Transforms
  textTransformCapitalize: 'capitalize',
  textTransformUppercase: 'uppercase'
};
